import React, { useState } from 'react';
import VacationRequest from './VacationRequest';
import VacationApprovalDashboard from './VacationApprovalDashboard';
import './VacationPortal.css';

export default function VacationPortal() {
  const [pin, setPin] = useState('');
  const [employee, setEmployee] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSupervisor, setIsSupervisor] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setEmployee(null);
    setLoading(true);

    try {
      const res = await fetch('/php/employee_portal.php?action=login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin })
      });

      if (!res.ok) {
        throw new Error('Nesprávny PIN alebo chyba načítania');
      }

      const data = await res.json();
      setEmployee(data);
      
      // Check if user is a supervisor by checking vacation_requests_api
      const checkRes = await fetch(`/php/vacation_requests_api.php?action=list&pin=${encodeURIComponent(pin)}`);
      if (checkRes.ok) {
        const checkData = await checkRes.json();
        setIsSupervisor(checkData.isSupervisor || false);
      }
    } catch (e) {
      setError(e.message || 'Chyba prihlásenia');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setEmployee(null);
    setPin('');
    setIsSupervisor(false);
    setError('');
  };

  // Not logged in - show login form
  if (!employee) {
    return (
      <div className="vacation-portal-login">
        <div className="login-card">
          <h2>Portál dovoleniek</h2>
          <p className="login-subtitle">Prihlásenie pomocou PINu</p>
          
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="pin">Váš PIN:</label>
              <input
                type="password"
                id="pin"
                inputMode="numeric"
                placeholder="Zadajte PIN (4-6 číslic)"
                maxLength="6"
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
                required
                disabled={loading}
              />
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <button 
              type="submit"
              className="login-button"
              disabled={loading}
            >
              {loading ? 'Prihlas ám sa...' : 'Prihlásiť sa'}
            </button>
          </form>

          <div className="login-info">
            <p><strong>Pokyny:</strong></p>
            <ul>
              <li>Zamestnanci si môžu podať žiadosť o dovolenku</li>
              <li>Nadriadzení môžu schvaľovať dovolenky svojich zamestnancov</li>
              <li>Všetky zmeny sú uložené a oznamujú sa emailom</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  // Logged in - show appropriate component
  return (
    <div className="vacation-portal-main">
      <div className="portal-header">
        <div className="header-content">
          <h1>Portál dovoleniek</h1>
          <button className="logout-button" onClick={handleLogout}>
            Odhlásiť sa
          </button>
        </div>
      </div>

      {isSupervisor ? (
        <VacationApprovalDashboard pin={pin} supervisorData={employee} />
      ) : (
        <VacationRequest pin={pin} employeeData={employee} />
      )}
    </div>
  );
}
